module.exports = __webpack_public_path__ + "static/media/06.-10-11.68c26809.jpg";